/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */


export const REQUEST_USER_ACCESS_MENU = 'REQUEST_USER_ACCESS_MENU';
export const REQUEST_USER_ACCESS_MENU_SUCCESS = 'REQUEST_USER_ACCESS_MENU_SUCCESS';
export const REQUEST_USER_ACCESS_MENU_FAILURE = 'REQUEST_USER_ACCESS_MENU_FAILURE';

export const REQUEST_DATA_TABLE_ACCESS_MENU = 'REQUEST_DATA_TABLE_ACCESS_MENU';
export const REQUEST_DATA_TABLE_ACCESS_MENU_SUCCESS = 'REQUEST_DATA_TABLE_ACCESS_MENU_SUCCESS';
export const REQUEST_DATA_TABLE_ACCESS_MENU_FAILURE = 'REQUEST_DATA_TABLE_ACCESS_MENU_FAILURE';

export const REQUEST_UPDATE_USER_ACCESS_MENU = 'REQUEST_UPDATE_USER_ACCESS_MENU';
export const REQUEST_UPDATE_USER_ACCESS_MENU_SUCCESS = 'REQUEST_UPDATE_USER_ACCESS_MENU_SUCCESS';
export const REQUEST_UPDATE_USER_ACCESS_MENU_FAILURE = 'REQUEST_UPDATE_USER_ACCESS_MENU_FAILURE';

export const REQUEST_SCOPE = 'REQUEST_SCOPE';
export const REQUEST_SCOPE_SUCCESS = 'REQUEST_SCOPE_SUCCESS';
export const REQUEST_SCOPE_FAILURE = 'REQUEST_SCOPE_FAILURE';

export const REQUEST_MASTER_MENU = 'REQUEST_MASTER_MENU';
export const REQUEST_MASTER_MENU_SUCCESS = 'REQUEST_MASTER_MENU_SUCCESS';
export const REQUEST_MASTER_MENU_FAILURE = 'REQUEST_MASTER_MENU_FAILURE';

export const REQUEST_CHANGE_USER_ACCESS_MASTER_MENU = 'REQUEST_CHANGE_USER_ACCESS_MASTER_MENU';
export const REQUEST_CHANGE_USER_ACCESS_MASTER_MENU_SUCCESS = 'REQUEST_CHANGE_USER_ACCESS_MASTER_MENU_SUCCESS';
export const REQUEST_CHANGE_USER_ACCESS_MASTER_MENU_FAILURE = 'REQUEST_CHANGE_USER_ACCESS_MASTER_MENU_FAILURE';

export const REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU = 'REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU';
export const REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU_SUCCESS = 'REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU_SUCCESS';
export const REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU_FAILURE = 'REQUEST_CHANGE_USER_ACCESS_MASTER_SUB_MENU_FAILURE';
